import type { AppProps } from 'next/app'

import { App as BaseApp } from '@components/App'
import { App as HubApp } from '@hub/App'

import '../styles/index.css'
import '../styles/typography.css'
import '@hub/components/controls/RichTextEditor/index.css'
import '../components/DropdownMenu/index.css'
import '@multifarm/solana-realms/dist/multifarm-solana-realms.css'
import queryClient from '@hooks/queries/queryClient'
import { QueryClientProvider } from '@tanstack/react-query'

export default function App({ Component, pageProps }: AppProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <BaseApp>
        <Component {...pageProps} />
      </BaseApp>
    </QueryClientProvider>
  )
}
